<template>
    <PopupRouterViewDetail label="Attachment Part Purchase Quality Control Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Attachment Part Purchase Quality Control" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="partPurchaseQualityControlDetails" optionsLabel="controlCard" optionsKey="id" label-cols-lg="12" label="Part Purchase Qc Detail" id="fieldset-part-purchase-q-c-detail" size="sm" :model.sync="model.partPurchaseQcDetailId"   :selected="model.partPurchaseQcDetail != null ? model.partPurchaseQcDetail.controlCard : ''" @input="getPartPurchaseQualityControlDetails" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPartPurchaseQCDetail" />
						<app-input-fileupload id="fieldset-evidence" label-cols-lg="12"  label="Evidence" size="sm" :model.sync="evidence"  :currentModel="model.evidence" @change="updateData"  :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import AttachmentPartPurchaseQualityControl from '@/models/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControl';
import AttachmentPartPurchaseQualityControlList from '@/models/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControlList';
import AttachmentPartPurchaseQualityControlFilter from '@/filters/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControlFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PartPurchaseQualityControlDetail from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControlDetail';
import PartPurchaseQualityControlDetailFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlDetailFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import Attachment from '@/models/Core/Attachment';
import AttachmentFilter from '@/filters/Core/AttachmentFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputFileupload,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			evidence: null,
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterAttachmentPartPurchaseQualityControl : null,
			currentAttachmentPartPurchaseQualityControlPage : 1,
			attachmentPartPurchaseQualityControlPageSize: 10,
			sortByAttachmentPartPurchaseQualityControl: '',
			sortDescAttachmentPartPurchaseQualityControl: '',
			partPurchaseQualityControlDetails: [],
			partPurchaseQcDetails: [],
			isPartPurchaseQCDetailComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartPurchaseQualityControlDetailComboLoading: false,
			isAttachmentComboLoading: false,
		}
	},
	methods : {
		getAttachmentPartPurchaseQualityControl : async function(id) {
			this.isBusy = true;
			AttachmentPartPurchaseQualityControl.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadAttachmentPartPurchaseQualityControl = true;
			this.filterAttachmentPartPurchaseQualityControl.id = this.modelId;
			AttachmentPartPurchaseQualityControl.downloadDataDetail(this, this.filterAttachmentPartPurchaseQualityControl).then(result => {
				this.isDownloadAttachmentPartPurchaseQualityControl = false;
			}).catch(error => { this.isDownloadAttachmentPartPurchaseQualityControl = false; })
		},
		getAttachmentPartPurchaseQualityControls : async function(input) {
			let filter = new AttachmentPartPurchaseQualityControlFilter();
			if (input != undefined) {
				filter.PartPurchaseQCDetail = input;
			}
			this.isAttachmentPartPurchaseQualityControlComboLoading = true;
			AttachmentPartPurchaseQualityControl.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.attachmentPartPurchaseQualityControls = result.data
				}
				this.isAttachmentPartPurchaseQualityControlComboLoading = false;
			})
			.catch(error => {});
		},
		getPartPurchaseQualityControlDetails : async function(input) {
			let filter = new PartPurchaseQualityControlDetailFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			PartPurchaseQualityControlDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControlDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPartPurchaseQCDetail(item) {
			if(item == undefined || item == null) {
				this.model.partPurchaseQcDetailId = null;
				this.model.partPurchaseQcDetail = null;
			} else {
				this.model.partPurchaseQcDetailId = item.id;
				this.model.partPurchaseQcDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.attachmentPartPurchaseQualityControlInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

			if (this.evidence != null) {
				let data = new FormData();
				data.append('file', this.evidence);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								model.evidenceId = response.data.id;
								model.evidence = response.data;
								_this.evidence = null;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						AttachmentPartPurchaseQualityControl.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'attachmentpartpurchasequalitycontrolindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						AttachmentPartPurchaseQualityControl.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'attachmentpartpurchasequalitycontrolindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			if (this.evidence != null) {
				let data = new FormData();
				data.append('file', this.evidence);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								model.evidenceId = response.data.id;
								model.evidence = response.data;
								_this.evidence = null;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					AttachmentPartPurchaseQualityControl.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getAttachmentPartPurchaseQualityControl(id);
					});
				}
			});
		},
		onHidden() {
			this.getAttachmentPartPurchaseQualityControls();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterAttachmentPartPurchaseQualityControl = new AttachmentPartPurchaseQualityControlFilter();
		//this.getPartPurchaseQualityControlDetails();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getAttachmentPartPurchaseQualityControl(id);
			} else {
				this.modelId = id;
				this.getAttachmentPartPurchaseQualityControl(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
